<template lang="pug">
  v-container()
    v-row(justify="center")
      v-col()
        v-btn(icon href="https://www.facebook.com/cityofrefugeucc/" target="_blank" )
          v-icon.mdi.mdi-facebook(x-large)
        span.headline  Facebook
</template>

<script>
// window.fbAsyncInit = function() {
//   FB.init({
//     appId: 'your-app-id',
//     autoLogAppEvents: true,
//     xfbml: true,
//     version: 'v6.0'
//   });
// };
export default {};
</script>

<style lang="stylus" scoped></style>
